import React, { useState, useEffect } from "react";
import {
  Button,
  Input,
  Form,
  Row,
  Col,
  Spin,
  Tooltip
} from "antd";
import { useStore } from "../../../../../../store";
import { contactUSkeys } from "../../../../../../config";
import { useTab } from "../../../../../../custom-hooks/useTab";
import {
  PlusOutlined,
  DeleteOutlined,
  QuestionCircleOutlined
} from "@ant-design/icons";
import { toast } from "react-toastify";


const { TextArea } = Input;
const MAX_CHARACTERS = 150;

const Address = ({ dataLoader, form, tabKey }) => {
  const { tabData, updatedValues } = useStore();
  const whichTab = contactUSkeys.address;
  const { deleteSingleItem, postLoader, getSingleTabData, dataLoader: tabDataLoader } = useTab();
  const [, setFormChanged] = useState(false);
  const [, SetLoading] = useState(postLoader || true);
  const [loader, setLoader] = useState(dataLoader || true);
  const [clearButtonDisabled, setClearButtonDisabled] = useState(true); // Default disabled

  const [initialValues, setInitialValues] = useState([])

  useEffect(() => {
    const isNotEmpty = Object.keys(updatedValues).length > 0;
    setFormChanged(isNotEmpty);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(updatedValues).length]);


  useEffect(() => {
    SetLoading(tabDataLoader || postLoader)
  }, [tabDataLoader, postLoader])

  const handleDelete = (whichTab, form, i, tabKey) => {
    SetLoading(true)
    deleteSingleItem(
      whichTab,
      form.getFieldValue([
        whichTab,
        i,
        "id",
      ]),
      form
    )
    getSingleTabData(tabKey, form);
    SetLoading(false)
  }

  // Function to check if clear button should be enabled
  const checkClearButtonState = (form) => {
    const currentList = form.getFieldValue(contactUSkeys.address) || [];

    // Check if there's at least one newly added item with content
    const hasNewItemWithContent = currentList.some(item =>
      !item?.id && item?.street && item.street.length > 0
    );

    setClearButtonDisabled(!hasNewItemWithContent);
  };


  useEffect(() => {

    if (!tabData?.ADDRESS) return;

    const addressList = tabData.ADDRESS;

    const tempInitialValues = addressList.map((item) => {
      const address = item?.addressOutputs?.[0];

      return {
        id: item?.id,
        street: address?.street || "",
        postalCode: address?.postalCode || "",
      };
    });

    // Update form FIRST
    form.setFieldsValue({
      [contactUSkeys.address]: tempInitialValues,
    });

    // Then update local state
    setInitialValues(tempInitialValues);

    // Then stop loaders
    setTimeout(() => {
      SetLoading(false)
      setLoader(false);


    }, 0);


    setClearButtonDisabled(true);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabData?.ADDRESS]);


  const handleSave = async () => {
    setLoader(false);
    try {
      const values = await form.validateFields(); // ✅ triggers validation UI

      console.log("Valid values:", values);
      await form.submit();
      setFormChanged(false);
      await getSingleTabData(tabKey);

    } catch (errorInfo) {
      toast.error(errorInfo);
    }
  };

  // const handleSave = async () => {
  //   setLoader(false);

  //   try {
  //     await form.submit();
  //     setFormChanged(false);

  //      // show loader only once

  //     await getSingleTabData(tabKey);

  //   } catch (errorInfo) {
  //     console.error("Form submission failed:", errorInfo);
  //     toast.error("Failed to add address");
  //     // setLoader(true);
  //   }
  // };


  if (dataLoader || postLoader || loader) {
    return <div className="data-loader"
      style={{
        position: "absolute",
        top: 0,
        bottom: 0,
        width: "100%",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
      <Spin tip="Loading" size="large" />
    </div>
  }

  return (
    <div>
      {tabKey === whichTab ? (
        <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          {/* {(!loading && initialValues) ?
          
            : <div className="data-loader">
              <Spin tip="Loading" size="large" />
            </div>} */}

          <Col className="gutter-row tabContent" span={15}>
            <Form.List
              name={contactUSkeys.address}
              initialValue={initialValues}
            >
              {(fields, { add, remove }) => {

                const handleItemDelete = (index, fieldName) => {
                  // Check if this is an existing item with data
                  const currentValues = form.getFieldValue(contactUSkeys.address) || [];

                  if (currentValues[index] && currentValues[index].id) {
                    // Existing item - call your delete handler
                    handleDelete(whichTab, form, index, tabKey);
                  } else {
                    // New item - just remove from the list
                    remove(fieldName);
                  }

                  // Check clear button state after deletion
                  setTimeout(() => checkClearButtonState(form), 0);
                };

                const handleAddMore = () => {
                  add(undefined, 0);
                  // Clear button should remain disabled until content is added
                  setClearButtonDisabled(true);
                };

                const handleClear = () => {
                  const path = contactUSkeys.address;
                  const values = form.getFieldValue(path) || [];
                  if (!values.length) return;

                  // Clear content of all newly added items
                  const newValues = values.map(item =>
                    !item?.id ? { ...item, street: "" } : item
                  );

                  form.setFieldsValue({ [path]: newValues });
                  setClearButtonDisabled(true);
                };

                return (
                  <div key={fields}>
                    <div
                      style={{ marginBottom: "10px" }}
                      className="inputBody"
                    >
                      <label></label>
                      <div
                        style={{ textAlign: "right" }}
                      >
                        {fields &&
                          fields.length <= 1 ? (
                          <></>
                        ) : (
                          <Button
                            className="cancelBtn"
                            type="button"
                            disabled={
                              clearButtonDisabled
                            }
                            onClick={handleClear}
                          >
                            Clear
                          </Button>
                        )}
                        <Button
                          className="greenBtn"
                          onClick={handleAddMore}
                        >
                          Add <PlusOutlined />
                        </Button>
                      </div>
                    </div>

                    {fields.map(
                      (
                        { key, name, ...restField },
                        i
                      ) => {
                        return (
                          <React.Fragment key={key}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Form.Item
                                className="w-100"
                                label={
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems:
                                        "center",
                                    }}
                                  >
                                    Full address
                                    including postal
                                    code
                                  </div>
                                }
                                labelCol={{ span: 9 }}
                                {...restField}
                                name={[name, "street"]}
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      "Address is required",
                                  },
                                  {
                                    max:
                                      MAX_CHARACTERS -
                                      1,
                                    message: `Description should be less than ${MAX_CHARACTERS} character`,
                                  },
                                ]}
                              >
                                <TextArea
                                  placeholder="Enter address with Street Name and postal-code"
                                  rows={2}
                                  maxLength={
                                    MAX_CHARACTERS
                                  }
                                  showCount
                                  onChange={() => {
                                    // Check clear button state when content changes
                                    setTimeout(
                                      () =>
                                        checkClearButtonState(
                                          form
                                        ),
                                      0
                                    );
                                  }}
                                />
                              </Form.Item>
                              <div
                                className="remove-btn"
                                style={{
                                  position: "relative",
                                  display: "flex",
                                }}
                              >
                                <DeleteOutlined
                                  style={{
                                    cursor: "pointer",
                                    paddingRight:
                                      "10px",
                                  }}
                                  title="Delete News"
                                  onClick={() =>
                                    handleItemDelete(
                                      i,
                                      name
                                    )
                                  }
                                />
                                <Tooltip
                                  title={
                                    "For locations on map"
                                  }
                                >
                                  <QuestionCircleOutlined />
                                </Tooltip>
                              </div>
                            </div>

                            <Form.Item
                              className="w-100"
                              style={{
                                display: "flex",
                                justifyContent: "end",
                              }}
                            >
                              <Button
                                className="saveBtn greenBtn"
                                onClick={() => {
                                  handleSave();
                                }}
                              >
                                Save
                              </Button>
                            </Form.Item>
                          </React.Fragment>
                        );
                      }
                    )}
                  </div>
                );
              }}
            </Form.List>
          </Col>
        </Row>) :
        (
          <></>
        )
      }
    </div>
  )
}
export default Address